import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import { State } from '../../redux/store';
import { InstructionInterface, ShowInstructionContext } from './types';
import { FaEdit } from 'react-icons/fa';
import { CiCircleRemove } from 'react-icons/ci';
import { useTranslation } from 'react-i18next';

const DataInstructions = () => {
  const { instructions } = useSelector((state: State) => state.instructions);

  const {
    showEditModal, setShowEditModal,
    showDeleteModal, setShowDeleteModal,
    setSelectedInstruction,
   } = useContext(ShowInstructionContext)

  const handleEditInstruction = (instrucion: InstructionInterface) => {
    setShowEditModal(!showEditModal)
    setSelectedInstruction(instrucion)
  }

  const handleDeleteInstruction = (instrucion: InstructionInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedInstruction(instrucion)
  }

  const { t } = useTranslation()

  return (
    <div className='grid md:grid-cols-3 mt-3'>
    {instructions.length > 0 && (
      <div className="col-span-2 flex flex-col border">
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full sm:px-6 lg:px-8">
            <div className="overflow-hidden invoice print:w-full">
              <table className="min-w-full text-center text-sm font-light border border-black">
                <thead className="border-b font-medium bg-main text-white border-black">
                  <tr>
                    <th className="px-2 py-2 border-black border-r">{t("Contenu en francais")}</th>
                    <th className="px-2 py-2 border-black border-r">{t("Contenu en arabe")}</th>
                    <th className="px-2 py-2 border-black print:hidden border-r">{t("Actions")}</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {
                  instructions
                  ?.map((instrucion: InstructionInterface, index) => (
                    <tr className="border-b border-black" key={index}>
                      <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium">
                        {instrucion.contentFr}
                      </td>
                      <td className="whitespace-nowrap px-2 py-2 border-black border-r font-medium">
                        {instrucion.contentAr}
                      </td>
                      <td className="flex justify-center items-center print:hidden border-r">
                        <FaEdit style={{ fontSize: "22px" }} className="text-second" onClick={() => handleEditInstruction(instrucion)}/>
                        <CiCircleRemove style={{ fontSize: "22px" }} className="text-red" onClick={() => handleDeleteInstruction(instrucion)}/>
                      </td>
                    </tr>
                  ))}
              </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  )
}

export default DataInstructions